/* eslint-disable import/no-unused-modules */

export const COMPLETE_PAYMENT_TYPO_CLASS = {
    // eg Amount due, "Credit / Debit", Subtotal, Total
    TWO_COLUMNS_KEY:
        'text-[#7E7E7E] font-display text-[0.8337rem] font-[450] leading-none tracking-[-0.0061rem]',
    TWO_COLUMNS_AMOUNT:
        'text-[#161616] font-display text-[1.87rem] font-[600] leading-none tracking-[-0.0138rem]',
    TWO_COLUMNS_VALUE:
        'text-[#7E7E7E] font-display text-[0.8337rem] font-[600] leading-none tracking-[-0.0061rem]',
};

export const PROPOSAL_TYPO_CLASS = {
    TAX_INVOICE_KEY:
        'text-black font-display text-[1.6706rem] font-[600] leading-none tracking-[-0.0334rem]',
    TAX_INVOICE_VALUE:
        'text-[#AFAFAF] font-display text-[1.6706rem] font-[600] leading-none tracking-[-0.0334rem]',
    ISSUSER_DETAILS:
        'text-[#505050] font-display text-[1rem] font-[450] leading-none',
    CLIENT_DETAILS:
        'text-[#505050] font-display text-[1rem] font-[450] leading-none',
    HEADLINE:
        'text-[#161616] font-display text-[2.3087rem] md:text-[4.7832rem] print:text-[4.7832rem] font-[600] leading-none tracking-[-0.0462rem] md:tracking-[-0.0957rem] print:tracking-[-0.0957rem]',
    NOTES: 'text-[#161616] font-display text-[1.3627rem] md:text-[1.125rem] print:text-[1.125rem] font-[600] leading-none md:leading-[1.2] print:leading-[1.2] tracking-[-0.0272rem] md:tracking-[-0.0225rem] print:tracking-[-0.0225rem]',
    CLIENT_DIRECTOR_NAME:
        'text-[#141414] font-sans text-[0.8572rem] font-[500] leading-[1.4]',
    CLIENT_DIRECTOR_INFO:
        'text-[#141414] font-sans text-[0.8572rem] font-[400] leading-[1.4]',
    CLIENT_DIRECTOR_BOOK_A_MEETING:
        'text-[#141414] font-sans text-[0.8572rem] font-[500] leading-[1.4] underline',
    // eg What this includes:
    WHAT_INCLUDES_TITLE:
        'text-[#929292] font-display text-[1.0001rem] font-[600] leading-none tracking-[-0.01rem]',
    WHAT_INCLUDES_TEXT:
        'text-[#161616] font-display text-[0.875rem] md:text-[1.3627rem] print:text-[1.3627rem] font-[600] leading-none tracking-[-0.0175rem] md:tracking-[-0.0272rem] print:tracking-[-0.0272rem]',
    // eg Invoice date:, Invoice number:, Your PO number:
    INVOICE_INFO_KEY:
        'text-[#6E6E6E] md:text-[#7E7E7E] print:text-[#7E7E7E] font-sans md:font-display print:font-display text-[0.6875rem] md:text-[1rem] print:text-[1rem] font-[400] md:font-[450] print:font-[450] leading-normal md:leading-none print:leading-none md:tracking-[-0.01rem] print:tracking-[-0.01rem]',
    INVOICE_INFO_VALUE:
        'text-[#141414] md:text-[#161616] print:text-[#161616] font-display text-[0.875rem] md:text-[1rem] print:text-[1rem] font-[600] leading-[0.8572rem] md:leading-none print:leading-none tracking-[-0.0088rem] md:tracking-[-0.01rem] print:tracking-[-0.01rem]',
    PRODUCT_TABLE_HEADER_MEMBERSHIP_TERM:
        'text-[#161616] font-sans text-[0.75rem] font-[500] leading-none',
    PRODUCT_TABLE_HEADER_MEMBERSHIP_TERM_VALUE:
        'text-[#161616] font-sans text-[0.75rem] font-[400] leading-none',
    PRODUCT_TABLE_HEADER:
        'text-[#9B9B9B] font-sans text-[0.5399rem] font-[500] leading-[0.7019rem] tracking-[-0.0054rem] uppercase',
    PRODUCT_TABLE_ROW_TITLE:
        'text-[#141414] font-sans text-[0.875rem] md:text-[0.8572rem] print:text-[0.8572rem] font-[500] leading-normal',
    PRODUCT_TABLE_ROW_DESC:
        'md:overflow-hidden print:overflow-hidden text-[#6E6E6E] md:text-ellipsis print:text-ellipsis font-sans text-[0.6875rem] md:text-[0.875rem] print:text-[0.875rem] font-[400] leading-normal',
    PRODUCT_TABLE_ROW_QTY:
        'overflow-hidden text-[#9B9B9B] md:text-[#6E6E6E] print:text-[#6E6E6E] text-ellipsis font-display md:font-sans print:font-sans text-[0.875rem] md:text-[0.6614rem] print:text-[0.6614rem] font-[600] md:font-[400] print:font-[400] leading-[0.8572rem] md:leading-normal print:leading-normal tracking-[-0.0088rem] md:tracking-[unset] print:tracking-[unset]',
    // eg UNIT PRICE, DISCOUNT, TAX
    PRODUCT_TABLE_ROW_UNIT_PRICE:
        'overflow-hidden text-[#9B9B9B] md:text-[#7E7E7E] print:text-[#7E7E7E] text-ellipsis font-display text-[0.875rem] md:text-[0.8572rem] print:text-[0.8572rem] font-[600] md:font-[450] print:font-[450] leading-[0.8572rem] tracking-[-0.0088rem] md:tracking-[-0.0086rem] print:tracking-[-0.0086rem]',
    PRODUCT_TABLE_ROW_PRICE:
        'text-[#141414] font-display text-[0.875rem] md:text-[0.8572rem] print:text-[0.8572rem] font-[600] leading-[0.8572rem] tracking-[-0.0088rem] md:tracking-[-0.0086rem] print:tracking-[-0.0086rem]',
    // eg Payment terms, Bank Transfer Payment, Credit Card Payment
    TERM_KEY:
        'text-[#929292] md:text-[#161616] print:text-[#161616] font-display md:font-sans print:font-sans text-[1.0001rem] md:text-[0.75rem] print:text-[0.75rem] font-[600] leading-none md:leading-normal print:leading-normal tracking-[-0.01rem] md:tracking-[unset] print:tracking-[unset]',
    TERM_VALUE:
        'text-[#161616] font-display md:font-sans print:font-sans text-[0.875rem] md:text-[0.75rem] print:text-[0.75rem] font-[600] md:font-[400] print:font-[400] leading-none md:leading-normal print:leading-normal tracking-[-0.0175rem] md:tracking-[unset] print:tracking-[unset]',
    SUMMARY_KEY:
        'overflow-hidden text-[#929292] text-ellipsis whitespace-nowrap font-display text-[1rem] font-[600] leading-none tracking-[-0.01rem]',
    SUMMARY_VALUE:
        'text-[#929292] font-display text-[1rem] font-[600] leading-none tracking-[-0.01rem]',
    SUMMARY_KEY_BOLD:
        'md:overflow-hidden print:overflow-hidden text-[#141414] md:text-ellipsis print:text-ellipsis font-display text-[1rem] font-[600] leading-[0.8572rem] tracking-[-0.01rem]',
    SUMMARY_VALUE_BOLD:
        'text-[#929292] md:text-[#141414] print:text-[#141414] font-display text-[1rem] font-[600] leading-none md:leading-[0.8572rem] print:leading-[0.8572rem] tracking-[-0.01rem]',
    // eg Scheduled Payments
    PAYMENT_TABLE_HEADER_TITLE:
        'text-[#929292] font-display text-[1.0001rem] font-[600] leading-none tracking-[-0.01rem]',
    PAYMENT_TABLE_HEADER:
        'text-[#9B9B9B] font-sans text-[0.5399rem] font-[500] leading-[0.7019rem] tracking-[-0.0054rem] uppercase',
    PAYMENT_TABLE_ROW_TITLE:
        'md:overflow-hidden print:overflow-hidden text-[#141414] md:text-ellipsis print:text-ellipsis font-sans text-[0.875rem] md:text-[0.7559rem] print:text-[0.7559rem] font-[500] leading-normal',
    // default
    PAYMENT_TABLE_ROW_STATUS:
        'text-white font-sans text-[0.7915rem] font-[500] leading-[1.1]',
    PAYMENT_TABLE_ROW_STATUS_OVERDUE:
        'text-[#943E3E] font-sans text-[0.7915rem] font-[500] leading-[1.1]',
    PAYMENT_TABLE_ROW:
        'overflow-hidden text-[#7E7E7E] text-ellipsis font-display text-[0.8572rem] font-[450] leading-[0.8572rem]',
    PAYMENT_TABLE_ROW_PAY_BUTTON_PAID:
        'text-white font-sans text-[1.0938rem] font-[500] leading-[1.1]',
    PAYMENT_TABLE_ROW_PAY_BUTTON_PAY:
        'text-[#141414] font-sans text-[1.0938rem] md:text-[1.0939rem] print:text-[1.0939rem] font-[500] leading-[1.1] md:leading-[1.3] print:leading-[1.3] md:tracking-[0.0219rem] print:tracking-[0.0219rem]',
    // eg ArchiPro Product Supplier Terms of Service (AU)
    FOOTER_TERMS_TITLE:
        'text-[#161616] font-display md:font-sans print:font-sans text-[1.0001rem] md:text-[1.2306rem] print:text-[1.2306rem] font-[600] leading-none md:leading-[1.1] print:leading-[1.1] tracking-[-0.01rem] md:tracking-[unset] print:tracking-[unset]',
    // eg ArchiPro, Mon 11 Aug, 2025
    FOOTER_TEXT:
        'text-[#929292] font-sans text-[0.6837rem] font-[400] leading-normal',
    BUTTON_ACCEPT_QUOTE:
        'text-[#161616] md:text-[#141414] print:text-[#141414] font-sans text-[1.125rem] md:text-[1rem] print:text-[1rem] font-[500] leading-[1.1] md:leading-[1.3] print:leading-[1.3] md:tracking-[0.02rem] print:tracking-[0.02rem]',
    // eg Confirm by 20 Aug to lock in this rate.
    DEADLINE_TEXT:
        'text-[#6E6E6E] md:text-[#141414] print:text-[#141414] font-sans text-[0.6875rem] md:text-[0.8572rem] print:text-[0.8572rem] font-[400] md:font-[500] print:font-[500] leading-normal',
    // eg Accept Quote, Decline Quote, Download PDF
    ACTION_BUTTON_TEXT:
        'text-[#161616] font-sans text-[1.125rem] font-[500] leading-[1.1]',
};
